function fixedHeader() {
	var scrollPosition = window.pageYOffset;
	var fixedStartPosition = siteHeader.offsetHeight + siteHeader.offsetTop;
	if (
		scrollPosition >= fixedStartPosition &&
		window.innerWidth > minimumWidth
	) {
		siteHeader.classList.add("is-fixed");
	} else if (body.classList.contains("menu-is-open")) {
		return false;
	} else {
		siteHeader.classList.remove("is-fixed");
	}
}